import { HOME_APPLY_PENDING_SPACE_REORDER } from '@core/constants/actions';
import { isHomeViewRole } from '@app/reducers/homeSpacesRoleState';
import { refreshHomeSpacesCardData } from './refreshHomeSpacesCardData';

const applyPendingHomeSpaceReorder =
  () => async (dispatch: (action: unknown) => unknown, getState: () => any) => {
    const pending = getState().home?.pendingSpaceReorder;

    dispatch({ type: HOME_APPLY_PENDING_SPACE_REORDER });

    if (pending && isHomeViewRole(pending.role)) {
      await dispatch(
        refreshHomeSpacesCardData([pending.spaceId], pending.role) as any
      );
    }
  };

export default applyPendingHomeSpaceReorder;
